import React from 'react';
import CoachVaultLogo from '/lovable-uploads/f2df824b-d722-4548-a26c-7d738f754338.png';
import { useIsMobile, useIsNarrowMobile } from '@/hooks/use-mobile';

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export const PageHeader = ({ title, description, children }: PageHeaderProps) => {
  const isMobile = useIsMobile();
  const isNarrowMobile = useIsNarrowMobile();

  return (
    <div className={`flex ${isMobile ? 'flex-col items-start' : 'items-center'} gap-4 mb-6 w-full`}>
      <div className="flex items-center gap-3">
        <img 
          src={CoachVaultLogo} 
          alt="Coach Vault Logo" 
          className={`${isNarrowMobile ? 'h-7 w-7' : isMobile ? 'h-8 w-8' : 'h-10 w-10'}`}
        />
        <div>
          <h1 className={`${isNarrowMobile ? 'text-xl' : isMobile ? 'text-2xl' : 'text-3xl'} font-bold text-coaching-dark`}>{title}</h1>
          {description && <p className={`text-muted-foreground ${isNarrowMobile ? 'text-xs' : ''}`}>{description}</p>}
        </div>
      </div>
      {children && <div className={`${isMobile ? 'mt-2 self-end' : 'ml-auto'}`}>{children}</div>}
    </div>
  );
};
